/**
 * Which slices survive a reload, and where.
 *
 * A whitelist, not a blacklist: only what is named here persists, everything
 * else stays in-memory Redux.
 *
 * Empty on purpose, for now: `toast` should never persist (toasts are
 * one-shot — replaying "Uploaded — reading the file now." after a reload
 * three days later is just wrong), and `workspace` already has its OWN
 * hand-rolled `localStorage` persistence (`workspaceSlice.ts`'s `STORAGE_KEY`,
 * read in `initialState` and written inside `selectAudit`). Whitelisting it
 * here too would mean two mechanisms writing the same value to two different
 * storage keys, racing on rehydration — worse than either alone. If a slice
 * that needs persistence and does NOT already have its own is added later,
 * name it here.
 *
 * `ui` (sidebar collapsed, colour theme) is a per-browser preference with
 * no storage of its own, so it persists here.
 */
import storage from 'redux-persist/lib/storage';

export const persistConfig = {
	key: 'reconcilio',
	storage,
	whitelist: ['ui'] as string[],
};
